import React from 'react';
import { useSelector } from 'react-redux';
import { getFileTypes } from 'src/slices/fileTypes';
import { Field } from '@gulfwinds/ui-components';
import { FormSelect } from 'shared/formControls';
import { BaseCell } from 'shared/grids/Cells';

const DocumentTypesSelectCell = ({ isField, onChange, ...props }) => {
  const documentTypes = useSelector(getFileTypes);
  const { dataItem, field } = props;

  if (isField) {
    return (
      <BaseCell>
        {dataItem.isInEdit ? (
          <Field
            component={FormSelect}
            name="documentTypeId"
            data={documentTypes}
            textField="name"
            dataItemKey="id"
            keyOnly
          />
        ) : dataItem.documentType}
      </BaseCell>
    );
  }

  const tryChange = (e) => {
    if (onChange) {
      onChange({
        dataIndex: 0,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.value,
      });
    }
  };

  const dataValue = dataItem[field];

  return (
    <BaseCell>
      <FormSelect
        data={documentTypes}
        textField="name"
        dataItemKey="id"
        keyOnly
        onChange={tryChange}
        {...props}
        value={dataValue}
      />
    </BaseCell>
  );
};

export default DocumentTypesSelectCell;
